import { render, staticRenderFns } from "./form2.vue?vue&type=template&id=1f3e6da6&scoped=true&"
import script from "./form2.vue?vue&type=script&lang=js&"
export * from "./form2.vue?vue&type=script&lang=js&"
import style0 from "./form2.vue?vue&type=style&index=0&id=1f3e6da6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3e6da6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f3e6da6')) {
      api.createRecord('1f3e6da6', component.options)
    } else {
      api.reload('1f3e6da6', component.options)
    }
    module.hot.accept("./form2.vue?vue&type=template&id=1f3e6da6&scoped=true&", function () {
      api.rerender('1f3e6da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/components/activityForm/components/form2.vue"
export default component.exports